import React from "react";
import * as c from "./lcArticleBlock.module.scss";
import { Link } from "gatsby";
import classNames from "classnames";
import ArrowIcon from "@icons/arrowIcon";

export default function LcArticleBlock({ className, node }) {
  const { lc_section, lc_category, slug, title } = node?.data?.target;

  const [category] = lc_category ?? [];
  const [section] = lc_section ? lc_section : category?.lc_section ?? [];

  const path = ["/learn", section?.slug, category?.slug, slug].filter((x) => x).join("/");

  return (
    <Link className={classNames(className, c.articleBlock)} to={path}>
      <span className={c.articleBlockTitle}>{title}</span>
      <ArrowIcon className={classNames(c.caret)} direction="right" />
    </Link>
  );
}
